export const SIDE_PANEL_WIDTH_OPEN = 350;
export const FILTER_NAME_MIN_WIDTH_EXPANDED = 110;
export const FILTER_NAME_MIN_WIDTH = 235;
export const FILTER_VALUE_MIN_WIDTH = 250;
export const FILTER_VALUE_MIN_WIDTH_EXPANDED = 95;
